module.exports = __webpack_public_path__ + "img/ergLogo1@2x.0b6fdbd4.jpg";